module.exports = __webpack_public_path__ + "media/images/flags/1x1/imn-f15a89874c029a38b3c7d74be63bbaeb.svg";